import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

import type { BarProps } from './Bar.types';

const Bar: React.FC<BarProps> = ({
  data,
  keys,
  indexBy,
  className,
  style,
  responsive = true,
  width = 400,
  height = 300,
  tooltip,
  ...rest
}) => {
  const containerStyle = { width: responsive ? '100%' : width, height, ...style };

  return (
    <div className={className} style={containerStyle}>
      <ResponsiveBar
        data={data}
        keys={keys}
        indexBy={indexBy}
        tooltip={tooltip}
        padding={0.3}
        animateOnMount
        axisLeft={{
          tickValues: 'auto',
        }}
        {...rest}
      />
    </div>
  );
};

export default Bar;
